// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__4TDBa","mainContent":"Layout_mainContent__NyGQv"};